module.exports = __webpack_public_path__ + "static/media/5f6a45aeb72e8.2fe4a551.jpg";